module.exports = __webpack_public_path__ + "static/img/icon-floor-item-1.f8154ad7.png";